import { Grid, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { tab } from '@testing-library/user-event/dist/tab';
import { AssociatedTeamMember, DataRoomUser, UnlockUser } from '../../../shared/models';
import { TeamMemberItem } from './TeamMemberItem';

interface ITeamMemberListProps {
	dataRoomGuid: string | null;
	isEmployee: boolean;
	user: DataRoomUser;
	members: AssociatedTeamMember[] | undefined;
	removeTeamMember: (member: AssociatedTeamMember) => void;
	sendInvite: (member: UnlockUser) => void;
}

export const TeamMemberList: React.FC<ITeamMemberListProps> = ({
	dataRoomGuid,
	isEmployee,
	user,
	members,
	removeTeamMember,
	sendInvite,
}) => {
	return (
		<>
			{members != null && members.length > 0 && dataRoomGuid && (
				<Grid container spacing={2} alignItems="stretch">
					<Table>
						<TableHead>
							<TableRow>
								<TableCell sx={{ minWidth: 300 }}>Name</TableCell>
								<TableCell sx={{ minWidth: 400 }}>Email</TableCell>
								<TableCell></TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{members.map(member => {
								return (
									<TeamMemberItem
										key={tab + '-' + member.guid}
										isEmployee={isEmployee}
										user={user}
										member={member}
										removeTeamMember={removeTeamMember}
										sendInvite={sendInvite}
									/>
								);
							})}
						</TableBody>
					</Table>
				</Grid>
			)}
		</>
	);
};
